import { render } from "./BuildingView.vue?vue&type=template&id=303a2522"
import script from "./BuildingView.vue?vue&type=script&lang=js"
export * from "./BuildingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__